<template>
  <div class="big-box">
    <div class="brand_change">
      <div class="container contents">{{ $hs("购物车","Shopping Cart","") }}</div>
    </div>
    <div class="container">
      <div class="cart-container">
        <div class="cart-list" v-show="userInfo.id ? gettingCart.length != 0 : getEnquiry[0].list.length != 0">
          <el-table
            size="mini"
            ref="cartTable"
            :data="userInfo.id ? gettingCart : getEnquiry[0].list"
            @select="selectRow"
            tooltip-effect="dark"
            @selection-change="selectionChange"
          >
            <el-table-column type="selection" prop="isCheck" align="center" width="42"></el-table-column>
            <el-table-column type="index" width="36" :label="$hs('ID', 'ID','ID')" align="center"></el-table-column>
            <el-table-column :label="$hs('图片', 'Picture','mágenes')" align="center">
              <template slot-scope="scope">
                <div class="pro-img">
                  <img
                    :src="scope.row.imgUrl || image"
                    alt
                    srcset
                    @click="$router.push({ path: '/proDetail', query: { coNu: scope.row.co_Nu } })"
                  />
                </div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('产品编号', 'Item NO.','Producto no.')" prop="co_Nu" align="center" width="114"></el-table-column>
            <el-table-column :label="$hs('产品详情', 'Description','Detalles del producto')" align="center">
              <template slot-scope="scope">
                <div class="col name">{{ $hs(scope.row.pr_Na,scope.row.pr_En_Na,scope.row.basicThreeLanguage) || ''}}</div>
              </template>
            </el-table-column>
            <el-table-column prop="price" :label="$hs('价格','Price','precio')" width="94" align="center">
              <template slot-scope="scope">
                <div class="price">{{ userInfo.symbol }}{{ userInfo.status === 1 ? scope.row.price : $hs('查看价格','SIGN IN') }}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('包装方式', 'Packing','Forma de embalaje')" align="center">
              <template slot-scope="scope">
                <div>{{ $hs(scope.row.ch_Pa, scope.row.en_Pa, scope.row.packThreeLanguage)}}</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('体积', 'CBM/CTN','volumen')" width="148" align="center">
              <template slot-scope="scope">
                <div>{{ scope.row.bulk_Stere }}CBM</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('总体积', ' T.CBM','Volumen total')" align="center">
              <template slot-scope="scope">
                <div>{{ Math.round(scope.row.bulk_Stere * scope.row.number * 1000) /1000 }}CBM</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('装箱量', 'QTY/CTN(Set)','Cantidad de contenedores')" align="center" width="100">
              <template slot-scope="scope">
                <div>{{ scope.row.ou_Lo }}PCS</div>
              </template>
            </el-table-column>
            <el-table-column :label="$hs('箱数','CTNS','Número de cajas')" prop="number" align="center" :render-header="renderheader">
              <template slot-scope="scope">
                <div class="input-number">
                  <!-- <div class="plus" @click="plusChange(scope.row)">
                    <i class="el-icon-plus"></i>
                  </div>-->
                  <el-input
                    v-if="isShowDom"
                    oninput="value=value.replace(/[^\d.]/g,'')"
                    @blur="updateNum(scope.row)"
                    v-model.number="scope.row.number"
                  ></el-input>
                  <!-- <div class="minus" @click="minusChange(scope.row)">
                    <i class="el-icon-minus"></i>
                  </div>-->
                </div>
              </template>
            </el-table-column>

            <el-table-column :label="$hs('合计价格','Total','Precio en total')" prop="total" :render-header="renderheader" align="center">
              <template slot-scope="scope">
                <div class="price">
                  <span>{{ userInfo.symbol }}{{ userInfo.status === 1 ? (scope.row.number * scope.row.price * scope.row.ou_Lo).toFixed(2) : '***'}}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column fixed="right" :label="$hs('操作','Operation','La operación')" width="100" align="center">
              <template slot-scope="scope">
                <div>
                  <el-button
                    @click.native.prevent="deleteRow(scope.row)"
                    type="text"
                    size="small"
                    style="color:#FF0000"
                  >{{$hs('删除','Delete','Borrar')}}</el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
          <div class="submit-box">
            <div class="right_selectbox">
              <el-checkbox v-model="isSelectAll" class="selectbox" @change="selectChange">{{$hs('全选','Select All','Selección Completa')}}</el-checkbox>
              <span class="remove" @click="clear">{{$hs('清除购物车','Clear Cart','Limpiar El Carrito')}}</span>
            </div>
            <div class="left">
              <div class="left_totalObj">
                <div>
                  <span>
                    {{$hs('产品数量', 'Total Records','Cantidad de productos')}}:
                    <span
                      style="color:#f2410f;"
                    >{{userInfo.id ? gettingCart.length : getEnquiry[0].list.length}}</span>
                  </span>
                </div>
                <div>
                  <span>
                    {{$hs('合计箱数','Total CTNS','Total de cajas')}}:
                    <span>{{ totalNumber }}</span>
                  </span>
                </div>
                <div>
                  <span>
                    {{$hs('合计装箱量','Total Quantity','Cantidad total de contenedores')}}:
                    <span>{{ totalouLo }}PCS</span>
                  </span>
                </div>
                <div>
                  <span>
                    {{ $hs('合计价格','Total Price','Precio en total') }}:
                    <span
                      style="color:#f2410f;"
                      v-if="userInfo.id"
                    >{{ userInfo.symbol }}{{totalPrice}}</span>
                    <span style="color:#f2410f;" v-else>***</span>
                  </span>
                </div>
              </div>
              <el-button
                type="primary"
                class="submit-btn"
                :loading="isLoading"
                @click="submitOrder"
                :disabled="!selectRows.length && userInfo.client_Nu !== null"
              >{{ $hs('提交清单','Submit','Enviar una lista') }}({{ selectRows.length }})</el-button>
            </div>
          </div>
        </div>
        <el-empty :description="$t('LLH.noData')" v-show="userInfo.id ? gettingCart.length == 0 : getEnquiry[0].list.length == 0"></el-empty>
      </div>
    </div>
  </div>
</template>
<script>
import { deletCartsApi } from '@/api/cart'
import { addOrder } from '@/api/order'
import { insertCartView } from '@/api/statistics'
import { mapGetters, mapActions, mapState } from 'vuex'
export default {
  name: 'pageCart',
  data() {
    return {
      gettingCartDisable: 0,
      drawer: false,
      direction: 'btt',
      checked: true,
      form: {
        consignee: '',
        email: '',
        purchaseUnit: '',
        needRemark: '',
        inquiryRemark: '',
      },
      image: "",
      productInfo: {
        piecesTotal: 0,
        kgsTotal: 0,
        m3Total: 0,
        sumTotal: 0
      },
      proInfo: {},
      rule: {
        consignee: [{ required: true, message: '请输入联系人', trigger: 'blur' }],
        email: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
        ]
      },
      rowData: {
        productRemark: ''
      },
      isSelectAllmobli: true,
      isSelectAll: true,
      recordRow: {},
      isShowDom: true,
      cartForm: {
        requirementRemarks: '',
        orderRemark: ''
      },
      cartFormRules: {},
      ruleForm: {
        consignee: '',
        mobile: '',
        email: '',
        inquiryRemark: ''
      },
      requirementRemarks: '',
      isLoading: false,
      rules: {
        email: [{ type: 'email', required: true, message: '', trigger: 'blur' }]
      },
      cartNum: 1,
      dialogVisible: false,
      checkAll: true,
      selectRows: []
    }
  },
  watch: {
    cartNum(value) {
      this.getProductInfo(value);
    }
  },
  computed: {
    ...mapGetters('operate', {
      gettingCart: 'getting_cart',
      getEnquiry: 'get_enquiry'
    }),
    ...mapGetters('user', {
      userInfo: 'get_userInfo'
    }),
    ...mapState('operate', ['language']),
    MobileTotalNumber() {
      let nums = 0;
      this.selectRows.map((item) => {
        if (item.isSelectproduct) {
          nums += Number(item.number)
        }
      }, 0)
      return Math.round(nums * 1000) / 1000
    },
    MobileLouLo() {
      let nums = 0;
      this.selectRows.map((item) => {
        if (item.isSelectproduct) {
          nums += (Number(item.ou_Lo) * item.number)
        }
      }, 0)
      return Math.round(nums * 1000) / 1000
    },
    // 总价格
    MobilelPrice() {
      let totalPrice = 0
      let data = this.userInfo.id ? this.gettingCart : this.getEnquiry[0].list
      data.forEach(item => {
        if (item.isSelectproduct) {
          totalPrice += item.number * item.price * item.ou_Lo
        }
      })
      return Math.round(totalPrice * 100) / 100
    },
    // 总箱数
    totalNumber() {
      return this.selectRows.reduce((total, item) => total + Number(item.number), 0)
    },
    totalouLo() {
      return this.selectRows.reduce((total, item) => total + (Number(item.ou_Lo) * item.number), 0)
    },
    // 总体积
    totalCMB() {
      return this.selectRows.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.bulk_Stere * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },
    // 总材积
    totalCUFT() {
      return this.selectRows.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.bulk_Feet * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },
    // 总毛重
    totalGW() {
      return this.selectRows.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.gr_We * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },
    // 总净重
    totalNW() {
      return this.selectRows.reduce((total, item) => {
        let num = (total * 10000 + item.number * item.ne_We * 10000) / 10000
        return Math.round(num * 1000) / 1000
      }, 0)
    },

    // 总价格
    totalPrice() {
      let totalPrice = 0
      let data = this.userInfo.id ? this.gettingCart : this.getEnquiry[0].list
      data.forEach(item => {
        totalPrice += item.number * item.price * item.ou_Lo
      })
      return Math.round(totalPrice * 100) / 100
    }
  },
  created() {
    console.log("xxx")
    if (this.userInfo.id) {
      this.deleteEnquiry('')
    } else {
      this.clearCart()
    }
    this.statisticsView()
  },
  mounted() {
    setTimeout(() => {
      this.$refs.cartTable.toggleAllSelection()
      let data = this.userInfo.id ? this.gettingCart : this.getEnquiry[0].list
      data.forEach((items) => {
        items.isSelectproduct = true;
      });
      this.gettingCartDisable = data.filter(items => items.isSelectproduct).length
    }, 200);
  },
  methods: {
    ...mapActions('operate', {
      addCart: 'add_cart',
      deleteCart: 'delete_cart',
      clearCart: 'clear_cart',
      batchDeleteCart: 'batch_delete_cart',
      deleteEnquiry: 'delete_enquiry',
      setEnquiry: 'set_enquiry',
      setnavItems: 'set_navItems'
    }),
    handleClose(done) {
      done();
      this.setnavItems(false)
    },
    selectChange(value) {
      if (value) {
        this.gettingCart.forEach(row => {
          this.$refs.cartTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.cartTable.clearSelection();
      }
    },
    mobileSelect() {
      this.gettingCart.forEach(row => {
        row.isSelectproduct = this.isSelectAllmobli
      });
      this.gettingCartDisable = this.gettingCart.filter(items => items.isSelectproduct).length
      let data = this.userInfo.id ? this.gettingCart : this.getEnquiry[0].list
      this.selectRows = data.filter(items => items.isSelectproduct)
    },
    mobilitemselect(value) {
      this.isSelectAllmobli = this.gettingCart.filter(items => items.isSelectproduct).length == this.gettingCart.length
      let data = this.userInfo.id ? this.gettingCart : this.getEnquiry[0].list
      this.gettingCartDisable = data.filter(items => items.isSelectproduct).length
      this.selectRows = data.filter(items => items.isSelectproduct)
    },
    // 统计访问
    statisticsView() {
      if (this.userInfo.id) {
        let obj = {
          mobile: this.userInfo.mobile || '',
          client_Na: this.userInfo.client_Na || '',
          userAccount: this.userInfo.userAccount || '',
          client_Nu: this.userInfo.client_Nu || '',
          pageUrl: this.$route.fullPath || ''
        }
        insertCartView(obj).then(() => { })
      }
    },
    renderheader(h, { column }) {
      // renderheader函数得用到el-table-column上
      return h('span', {}, [
        h('span', {}, column.label.split('//')[0]), // 其中//也可以用其他符号替代
        h('br'),
        h('span', {}, column.label.split('//')[1])
      ])
    },
    getProductInfo(num) {
      this.productInfo.piecesTotal = Math.round((this.proInfo.ou_Lo * num) * 1000) / 1000
      this.productInfo.kgsTotal = Math.round((this.proInfo.gr_We * num) * 1000) / 1000
      this.productInfo.m3Total = Math.round((this.proInfo.tiji * num) * 1000) / 1000
      this.productInfo.sumTotal = Math.round((this.proInfo.ou_Lo * this.proInfo.price * num) * 1000) / 1000
    },
    tanchuFun(options) {
      this.drawer = true;
      this.proInfo = options
      this.cartNum = options.number
      this.getProductInfo(options.number)
      this.setnavItems(true)
    },
    plusChange(row) {
      console.log('row :>> ', row);
      row.number++
      this.updateNum(row)
    },
    minusChange(row) {
      row.number--
      this.updateNum(row)
    },
    cartNumPlus(typeStr) {
      if (typeStr === 'plus') {
        this.cartNum++
      }
      if (typeStr === 'minus') {
        if (this.cartNum == 0) return
        this.cartNum--
      }
    },
    cartNumsFun(number) {
      if (!number) {
        this.isShowDom = false
        this.$nextTick(() => {
          this.cartNum = 0
          this.isShowDom = true
        })
      }
      this.cartNum = number
    },
    tujiao() {
      this.proInfo.number = this.cartNum
      this.updateNum(this.proInfo)
      this.drawer = false
      this.setnavItems(false)
    },
    remarksRow(row) {
      this.dialogVisible = true
      this.recordRow = row
      this.rowData.productRemark = row.productRemark
    },
    // 删除购物车数据
    deleteRow(row) {
      if (!this.userInfo.id) {
        this.deleteEnquiry(row)
        return
      }
      let _this = this
      this.$confirm(this.$hs("是否删除该条数据？", "Do you want to empty your shopping cart?"), this.$hs("系统提示", "Tip"), {
        confirmButtonText: this.$hs("提交", "Confim", ""),
        cancelButtonText: this.$hs("取消", "Cancel", ""),
        type: 'warning'
      })
        .then(() => {
          if (this.userInfo) {
            deletCartsApi({
              userId: this.userInfo.id,
              coNus: [row.co_Nu]
            }).then(res => {
              if (res.success) {
                this.deleteCart(row.co_Nu)
              }
            })
          }
          _this.$message({
            type: 'success',
            message: _this.$hs("删除成功", 'deleteSuccess')
          })
        })
        .catch(() => { })
    },
    // 修改数量
    updateNum(row) {
      if (this.userInfo.id) {
        this.addCart({
          client_Nu: this.userInfo.client_Nu,
          userId: this.userInfo.id,
          co_Nu: row.co_Nu,
          fa_No: row.fa_No,
          imgUrl: row.imgUrl,
          in_En: row.in_En,
          number: row.number,
          ou_Lo: row.ou_Lo,
          pr_En_Na: row.pr_En_Na,
          pr_Na: row.pr_Na,
          price: row.price,
          bulk_Stere: row.bulk_Stere,
          bulk_Feet: row.bulk_Feet,
          gr_We: row.gr_We,
          ne_We: row.ne_We,
          productRemark: row.productRemark,
        })
      } else {
        this.isShowDom = false
        this.$nextTick(() => {
          this.isShowDom = true
        })
      }
    },
    // 选中全部
    selectAll() {
      // if (this.gettingCart.length === 0 || this.getEnquiry[0].list.length === 0)
      //   return
      this.checkAll = this.checkAll
      this.$refs.cartTable.toggleAllSelection()
    },
    // 选中
    selectionChange(rows) {
      this.selectRows = rows
      console.log('rows :>> ', rows)
      // this.checkAll = rows.length === this.gettingCart.length || rows.length === this.getEnquiry[0].list.length
    },

    selectRow(selection, row) {
      if (selection.length === 0) {
        this.checkAll = false
      }
    },

    // 清空购物车
    clear() {
      if (!this.userInfo.id) {
        for (let i = 0; i < this.selectRows.length; i++) {
          this.deleteEnquiry(this.selectRows[i])
        }
        return
      }

      let _this = this
      let newArr = []
      _this.gettingCart.forEach(value => {
        if (value.co_Nu) {
          newArr.push(value.co_Nu)
        }
      })

      this.$confirm(this.$hs("是否清空全部购物车？", "Do you want to empty your shopping cart?"), this.$hs("系统提示", "Tip"), {
        confirmButtonText: this.$hs("提交", "Confim", ""),
        cancelButtonText: this.$hs("取消", "Cancel", ""),
        type: 'warning'
      })
        .then(() => {
          if (_this.userInfo) {
            deletCartsApi({
              userId: _this.userInfo.id,
              coNus: newArr
            }).then(res => {
              if (res.success) {
                _this.clearCart()
                _this.selectRows = []
              }
            })
          }
          _this.$message({
            type: 'success',
            message: _this.$hs("删除成功", 'deleteSuccess')
          })
        })
        .catch(() => { })
      this.setnavItems(true)
    },

    onConfirm() {
      this.recordRow.productRemark = this.rowData.productRemark
      this.updateNum(this.recordRow)
      this.dialogVisible = false
      this.isShowDom = false
      this.$nextTick(() => {
        this.isShowDom = true
      })
    },

    // 提交订单
    submitOrder() {
      this.setnavItems(true)
      if (!this.userInfo.id) {
        const _this = this
        this.$refs.form.validate(valid => {
          if (valid) {
            let obj = {
              consignee: _this.form.consignee,
              email: _this.form.email,
              purchaseUnit: _this.form.purchaseUnit,
              inquiryRemark: _this.form.inquiryRemark,
              needRemark: _this.form.needRemark,
              products: []
            }
            _this.selectRows.forEach(item => {
              obj.products.push({
                co_Nu: item.co_Nu, productRemark: item.productRemark,

                number: item.number
              })
            })

            this.$confirm(this.$hs("确认提交询单？", "Confirm submitting the inquiry?"), this.$hs("系统提示", "Tip"), {
              confirmButtonText: this.$hs("提交", "Confim", ""),
              cancelButtonText: this.$hs("取消", "Cancel", ""),
              type: 'warning'
            })
              .then(() => {
                _this.isLoading = true
                const loading = this.$loading({
                  lock: true,
                  text: this.$hs("加载中...", "loading"),
                  spinner: 'el-icon-loading',
                  background: 'rgba(0, 0, 0, 0.7)'
                })
                // createInquiryLLH(obj)
                //   .then(res => {
                //     if (res.success) {
                //       let title = _this.$hs(
                //         '您的询单已提交，我们会有专门的业务员与您联系，感谢您的来访。',
                //         'Your inquiry has been submitted, and we will have a dedicated salesperson to contact you. Thank you for your visit.',
                //         'Su formulario de consulta ha sido presentado y tendremos un vendedor especial para contactar con usted, gracias por su visita.'
                //       )
                //       _this.$alert(title, _this.$t('LLH.systemTip'), {
                //         confirmButtonText: _this.$t('LLH.confirm'),
                //         callback: action => { }
                //       })
                //       _this.clear()
                //       _this.$refs.form.resetFields()
                //     } else {
                //       _this.$message.error('询价失败' + res.message)
                //     }
                //   })
                //   .catch(err => {
                //     _this.$message.error('询价失败' + err.message)
                //   })
                //   .finally(() => {
                //     loading.close()
                //     _this.isLoading = false
                //   })
              })
              .catch(() => { })
          } else {
            _this.$message.warning('请填写联系人和邮箱信息')
            document.documentElement.scrollTop = 0
            return false
          }
        })
        return
      } else {
        let _this = this
        let newArr = []
        this.$confirm(this.$hs("确认提交询单？", "Confirm submitting the inquiry?"), this.$hs("系统提示", "Tip"), {
          confirmButtonText: this.$hs("提交", "Confim", ""),
          cancelButtonText: this.$hs("取消", "Cancel", ""),
          type: 'warning'
        })
          .then(() => {
            const orderParam = {
              userAccount: _this.userInfo.userAccount,
              email: _this.userInfo.email,
              consignee: _this.userInfo.userName,
              mobile: _this.userInfo.mobile,
              address: _this.userInfo.address,
              requirementRemarks: _this.cartForm.requirementRemarks,
              orderRemark: _this.cartForm.orderRemark,
              orderDetails: _this.selectRows.map(item => {
                return Object.assign({}, { co_Nu: item.co_Nu, number: item.number, productRemark: item.productRemark })
              })
            }

            _this.isLoading = true
            const loading = this.$loading({
              lock: true,
              text: this.$hs("加载中...", "loading"),
              spinner: 'el-icon-loading',
              background: 'rgba(0, 0, 0, 0.7)'
            })
            addOrder(orderParam)
              .then(res => {
                if (res.success) {
                  _this.$message.success(_this.$hs("订单创建成功！", 'orderSuccess'))

                  // 清除vuex缓存
                  _this.selectRows.forEach(ite => {
                    _this.gettingCart.forEach(item => {
                      if (ite.co_Nu == item.co_Nu) {
                        newArr.push(ite.co_Nu)
                      }
                    })
                  })
                  // 购物车商品生成订单成功后
                  deletCartsApi({
                    userId: _this.userInfo.id,
                    coNus: newArr
                  }).then(res => {
                    if (res.success) {
                      _this.batchDeleteCart(newArr)
                    }
                  })
                  // 清除表格选中
                  _this.$refs.cartTable.clearSelection()
                  _this.$router.push({
                    path: '/order/detail',
                    query: { orderNo: res.data }
                  })
                } else {
                  _this.$message.error(res.message)
                }
              })
              .catch(err => {
                _this.$message.error(err)
              })
              .finally(() => {
                loading.close()
                _this.isLoading = false
                this.setnavItems(false)
                this.setnavItems(true)
              })
          })
          .catch(() => {
          }).finally(() => {
            _this.isLoading = false
            this.setnavItems(false)
            this.setnavItems(true)
          })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.big-box {
  background-color: #fff;
  padding: 10px 0;
  ::v-deep .el-card__body {
    padding: 0 !important;
  }
  .brand_change {
    width: 100%;
    height: 48px;
    font-size: 16px;
    font-weight: 400;
    text-align: left;
    color: #222222;
    line-height: 48px;
    margin-top: 40px;
  }
  .cart-container {
    min-height: 400px;
    margin-bottom: 40px;
    .remarks {
      padding: 0 0 20px 0;
      .flex {
        display: flex;
        justify-content: space-between;
        :deep(.el-form-item) {
          width: 360px;
        }
      }
      :deep(.el-form-item) {
        margin: 0 !important;
        .el-form-item__label,
        .el-form-item__content {
          line-height: 36px;
          padding: 0px !important;
        }
        .el-form-item__error {
          display: none;
        }
      }
    }

    & .cart-list {
      border: 1px solid #f4f0ea;
      box-shadow: 0px 3px 6px 0px rgba(0, 0, 0, 0.06);
      & .pro-img {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 96px;
        height: 72px;
        & img {
          width: auto;
          height: auto;
          max-width: 96px;
          max-height: 72px;
        }
      }

      & .price {
        color: #ff0000;
        font-weight: bold;
      }

      & .action-list {
        display: flex;
        justify-content: space-between;
        padding-top: 20px;

        & .action {
          display: flex;
          height: 32px;
          align-items: center;

          & .del-cart {
            cursor: pointer;
            margin-left: 30px;
            color: #f2410f;
            border: 1px solid #f2410f;
            padding: 5px 15px;
            border-radius: 5px;
            font-size: 14px;

            .del-icon {
              margin-right: 10px;
            }
          }
        }

        & .count {
          display: flex;
          align-content: center;

          & p {
            margin-left: 20px;
            text-align: right;

            & span {
              color: #f2410f;
              font-size: 18px;
              margin-left: 5px;
            }
          }
        }
      }
    }
  }

  .submit-box {
    display: flex;
    height: 50px;
    margin: 15px 0;
    background-color: #fff;
    border-radius: 2px;
    font-size: 14px;
    color: #222222;
    .right_selectbox {
      width: 25%;
      display: flex;
      align-items: center;
      .selectbox {
        margin-left: 12px;
      }
      .remove {
        cursor: pointer;
        border-radius: 2px;
        margin-left: 30px;
        color: #ff0000;
      }
    }
    .left {
      width: 75%;
      display: flex;
      align-items: center;
      justify-content: space-between;
      .left_totalObj {
        display: flex;
        align-items: center;
        > div {
          margin: 0 10px;
          display: flex;
          > span:nth-child(1) {
            width: 150px;
            display: block;
          }
          span {
            font-size: 14px;
            font-family: Arial, Arial-Regular;
            font-weight: 400;
            text-align: right;
            color: #222222;
            line-height: 33px;
          }
        }
      }

      button {
        width: 200px;
        height: 40px;
        background: #ff0000;
        border: 1px solid #ff0000;
        margin-right: 20px;
      }
    }
  }
}
.input-number {
  display: flex;
  flex-direction: column;
  align-items: center;
  .el-input {
    ::v-deep input {
      padding: 0;
      width: 74px;
      height: 34px;
      border: 1px solid #dfdfdf;
      border-radius: 4px;
      text-align: center;
    }
  }

  .minus,
  .plus {
    height: 34px;
    line-height: 30px;
    font-size: 18px;
    width: 50px;
    border: 1px solid #dcdfe6;
    border-radius: 26px 26px 0 0;
    background-color: #fff;
    text-align: center;
    cursor: pointer;
    &:hover {
      color: #409eff;
      border: 1px solid #409eff;
    }
  }
  .plus {
    border-bottom: 1px solid #fff;
    border-radius: 26px 26px 0 0;
  }
  .minus {
    border-top: 1px solid #fff;
    border-radius: 0 0 26px 26px;
  }
}

.col {
  color: #999999;
  font-size: 12px;
  &.name {
    font-size: 16px;
    font-family: Arial, Arial-Regular;
    font-weight: 400;
    text-align: center;
    color: #222222;
    word-break: keep-all;
    line-height: 33px;
  }
  &.num {
    color: #666666;
    font-size: 12px;
    font-weight: bold;
    margin: 4px 0;
  }
}

:deep(.el-form-item__error) {
  display: none;
}

.submit-btn {
  background-color: #00923f;
  border-color: #00923f;
}
:deep(.is-disabled) {
  background-color: #c5c5c5 !important;
  border-color: #c5c5c5 !important;
}

:deep(.el-empty) {
  padding: 80px;
}
:deep(.el-checkbox__label) {
  font-size: 14px;
  font-family: Arial, Arial-Regular;
  font-weight: 400;
  text-align: left;
  color: #999999 !important;
  line-height: 33px;
}

:deep(.is-checked .el-checkbox__inner) {
  background-color: #ff0000 !important;
  border-color: #ff0000 !important;
}

::v-deep .van-checkbox__label {
  font-size: 0.32rem;
  font-family: Arial, Arial-Bold;
  font-weight: 700;
  text-align: left;
  color: #222222;
}

.mobilProduct_checkedSelect {
  display: flex;
  justify-content: space-between;
  width: 6.9rem;
  margin: 0.1rem auto;
  padding: 0.18rem 0;
  .delete {
    font-size: 0.24rem;
    font-family: PingFang SC, PingFang SC-Regular;
    font-weight: 400;
    text-align: right;
    color: #ff0000;
  }
}

.bottom_table {
  margin-top: 0.2rem;
  padding-left: 0.3rem;
  table {
    width: 6.9rem;
    border-collapse: collapse;
    border-spacing: 0;
    td {
      width: 1.3rem;
      height: 0.57rem;
      border: 1px solid #dcdee2;
      text-align: center;
    }
    thead {
      font-size: 0.24rem;
      font-family: Arial, Arial-Regular;
      font-weight: 400;
      text-align: left;
      color: #222222;
      line-height: 26px;
      letter-spacing: -0.8px;
    }

    tbody {
      font-size: 0.24rem;
      font-family: Arial, Arial-Regular;
      font-weight: 400;
      text-align: left;
      color: #666666;
      letter-spacing: -0.8px;
    }
  }
  ::v-deep .el-input {
    width: 1rem;
    padding: 0px;
  }
  ::v-deep .el-input__inner {
    padding: 0px 0px !important;
    height: 0.52rem;
    text-align: center;
    font-size: 0.24rem;
  }
}

.submit_Cart {
  width: 6.9rem;
  height: 0.6rem;
  background: #ff6700;
  font-size: 0.28rem;
  color: #fff;
  text-align: center;
  line-height: 0.6rem;
  border-radius: 0.06rem;
  margin-left: 0.3rem;
  margin-top: 0.3rem;
}
</style>